// extracted by mini-css-extract-plugin
module.exports = {"featuredTitle":"_8e05236","featuredTitleText":"_09fcc19"};